export const USER_ADDRESS = "USER_ADDRESS";
export const USER_DOCUMENTS = "USER_DOCUMENTS";
export const UPDATE_USER_DOCUMENT = "UPDATE_USER_DOCUMENT";
export const USER_VECHICLES = "USER_VECHICLES";
export const UPDATE_USER_VEHICLE = "UPDATE_USER_VEHICLE";
export const USER_MAP_ADDRESS = "USER_MAP_ADDRESS";
export const USER_CUR_LAT_LONG = "USER_CUR_LAT_LONG";
export const UPDATE_VEHICLE_DEFAULT_ADDRESS = "UPDATE_VEHICLE_DEFAULT_ADDRESS";
export const DELETE_VEHICLE = "DELETE_VEHICLE";
export const DELETE_ADDRESS = "DELETE_ADDRESS";
export const STORE_CITY_STATE = "STORE_CITY_STATE";
export const EDIT_ADDRESS_ID = "EDIT_ADDRESS_ID";
export const EDIT_USER_ADDRESS = "EDIT_USER_ADDRESS";
export const GET_RECOMMENDED_SERVICES = "GET_RECOMMENDED_SERVICES";
export const GET_RECOMMENDED_SERVICES_SUCCESS = "GET_RECOMMENDED_SERVICES_SUCCESS";
export const GET_RECOMMENDED_SERVICES_FAILED = "GET_RECOMMENDED_SERVICES_FAILED";
export const FORM_CAR_SLIDE_DATA = "FORM_CAR_SLIDE_DATA";
export const WITH_SEARCH_RECOMMENDATIONS = "WITH_SEARCH_RECOMMENDATIONS";
export const WITH_SEARCH_RECOMMENDATIONS_SUCCESS = "WITH_SEARCH_RECOMMENDATIONS_SUCCESS";
export const WITH_SEARCH_RECOMMENDATIONS_FAILED = "WITH_SEARCH_RECOMMENDATIONS_FAILED";
export const GET_FAQS = "GET_FAQS";
export const GET_FAQS_SUCCESS = "GET_FAQS_SUCCESS";
export const GET_FAQS_FAILED = "GET_FAQS_FAILED";
export const SAVE_SEARCH_SERVICE_DATA = "SAVE_SEARCH_SERVICE_DATA";
export const SAVE_CATELOG_VEHICLE_ID = "SAVE_CATELOG_VEHICLE_ID";
export const SAVE_ADDRESS_DID_REF = "SAVE_ADDRESS_DID_REF";

export const GET_SERVICE_DETAILS = "GET_SERVICE_DETAILS";
export const GET_SERVICE_DETAILS_SUCCESS = "GET_SERVICE_DETAILS_SUCCESS";
export const GET_SERVICE_DETAILS_FAILED = "GET_SERVICE_DETAILS_FAILED";

export const SAVE_WORKSHOP_STANDARD = "SAVE_WORKSHOP_STANDARD";
export const SAVE_LOCATION_STATUS = "SAVE_LOCATION_STATUS";

export const SAVE_USER_VEHICLES = "SAVE_USER_VEHICLES";

export const GET_USER_REFERAL_DETAILS = "GET_USER_REFERAL_DETAILS";
export const GET_USER_REFERAL_DETAILS_SUCCESS = "GET_USER_REFERAL_DETAILS_SUCCESS";
export const GET_USER_REFERAL_DETAILS_FAILED = "GET_USER_REFERAL_DETAILS_FAILED";
export const SAVE_USER_REFERAL = "SAVE_USER_REFERAL";
export const SAVE_USER_REFERAL_SUCCESS = "SAVE_USER_REFERAL_SUCCESS";
export const SAVE_USER_REFERAL_FAILED = "SAVE_USER_REFERAL_FAILED";

export const GET_VEHICLE_IMAGE = "GET_VEHICLE_IMAGE";
export const GET_VEHICLE_IMAGE_SUCCESS = "GET_VEHICLE_IMAGE_SUCCESS";
export const GET_VEHICLE_IMAGE_FAILED = "GET_VEHICLE_IMAGE_FAILED";

export const GET_APP_VERSIONS = "GET_APP_VERSIONS";
export const GET_APP_VERSIONS_SUCCESS = "GET_APP_VERSIONS_SUCCESS";
export const GET_APP_VERSIONS_FAILED = "GET_APP_VERSIONS_FAILED";
